module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_09_stay-2aab8e778ed346114100d2a9635db5bc.jpg";